import { Injectable } from '@angular/core';
import { Usuario } from 'src/app/models/entities/usuario';
import { AngularFireDatabase } from '@angular/fire/database';
import { Observable } from 'rxjs';
import { database } from 'firebase';
import { map, tap } from 'rxjs/operators';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {

  public path: string;
  public constructor(public angularFireDatabase: AngularFireDatabase, public afs: AngularFirestore) {
    this.path = "usuarios";
  }

  public save(usuario: Usuario): Promise<any> {
    return this.angularFireDatabase.list<Usuario>(this.path).push(usuario);
  }

  public findAll(): Observable<Usuario[]> {
    return this.angularFireDatabase.list<Usuario>(this.path).snapshotChanges().pipe(
      map(
        changes =>
          changes.map(c => (
            ({
              key: c.payload.key,
              ...c.payload.val()
            } as Usuario)
          ))
      )
    );
  }

  public findByCorreo(correo: string): Observable<Usuario> {
    let query = (ref: database.Reference): database.Query => {
      return ref.orderByChild('correo').equalTo(correo);
    }
    return this.executeQuery(query);
  }

  public executeQuery(createQuery: any): Observable<Usuario> {
    return this.angularFireDatabase.list<Usuario>(this.path, (ref: database.Reference) => createQuery(ref)).snapshotChanges().pipe(
      map(
        changes =>
          changes.map(c => (
            ({
              key: c.payload.key,
              ...c.payload.val()
            } as Usuario)
          ))
      ),
      map(
        usuarios => usuarios[0]
      )
    );
  }

  public updateUsuario(key: string, usuario: Usuario): Promise<any> {
    return this.angularFireDatabase.list<Usuario>(this.path).update(key, usuario);
  }

  public findByKey(key: string): Observable<Usuario> {
    return this.angularFireDatabase.object<Usuario>(this.path + "/" + key).snapshotChanges().pipe(
      map(c =>
        ({
          key: c.payload.key,
          ...c.payload.val()
        } as Usuario)
      )
    );
  }

}
